import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'dg-emp-search-lib';
@Component({
  selector: 'app-select-a-file',
  templateUrl: './select-a-file.component.html',
  styleUrls: ['./select-a-file.component.scss'],
})
export class SelectAFileComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  ngOnInit(): void {
    console.log();
  }
}
